import {put, select} from 'redux-saga/effects';
import axios from 'src/api/Api';
import {GET_PRODUCTS_BULK_SUCCESS, GET_PRODUCTS_BULK_FAILURE} from '../actions';
import {convertObjectToQueryParams, updateIsAllTerritoryId} from 'src/utils/util';
import {errorHandler} from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

const getSearchProductPromises = (cfnArray, territoryId, isUHOrder, isMastOrder, isMastOrderTemplate) => {
    const searchProductsPromiseArray = [];
    let url = `occ/v2/${
        localStorage.getItem('baseSiteId')
    }/products/productList?`;
    const cfnArrayCloned = [...cfnArray];
    while (cfnArrayCloned.length) {
        searchProductsPromiseArray.push(axios.get(`${url}${
            convertObjectToQueryParams({
                searchParam: 'productNumber',
                orderType: 'ZLC',
                searchTerm: cfnArrayCloned.splice(0, 10).join(),
                territoryId: updateIsAllTerritoryId(territoryId),
                isMastOrder:isMastOrder || isMastOrderTemplate,
            })
        }&uhOrder=${
            isUHOrder ? isUHOrder : false
        }`).then((response) => response.data));
    }

    return searchProductsPromiseArray;
};

const ErrorCheck = (productsList) => {
    if (productsList ?. length > 0) {
        return productsList;
    } else {
        return [];
    }
};

export default function* searchProductsBulk (action) {
    try {
        const {territoryId, isUHOrder} = yield select((state) => ({
            territoryId: state.surgeryReducer.surgeryDetails.territoryId,
            isUHOrder: state.surgeryDetailsReducer ?. surgeryData ?. surgeryDetails ?. isSEorUH
        }));
        const { isMastOrder } = yield select((state) => ({
            isMastOrder: state.loginReducer.isMastOrder
        }));
        const { isMastOrderTemplate } = yield select((state) => ({
            isMastOrderTemplate: state.commonTemplateReducer.isMastOrderTemplate
        }));
        const results = yield Promise.all(getSearchProductPromises(action.payload || [], territoryId, isUHOrder, isMastOrder, isMastOrderTemplate));


        let mergedResult = [];
        results.forEach(({productsList}) => {
            mergedResult = [
                ... mergedResult,
                ... ErrorCheck(productsList)
            ];
        });
        const finalResult = [];
        action.payload && action.payload.forEach((productNumber) => {
            const fetchedProduct = mergedResult.find((result) => result.cfn.toUpperCase() === productNumber.toUpperCase());
            if (fetchedProduct) {
                finalResult.push({
                    ... fetchedProduct,
                    quantity: 1
                });
            } else {
                finalResult.push({cfn: productNumber, quantity: 0, isPlusIconDisable:true});
            }
        });
        yield put({
            type: GET_PRODUCTS_BULK_SUCCESS,
            products: finalResult.sort(
                (a, b) => a.quantity - b.quantity
            ),
            statusCode: results[0].statusCode,
            statusMessage: results[0].statusMessage
        });
    } catch (e) {
        const url = `occ/v2/${localStorage.getItem('baseSiteId')}/products/productList`;
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({type: GET_PRODUCTS_BULK_FAILURE, statusCode: errorHandler('503'), statusMessage: e.Error});
    }
}
